module.exports = __webpack_public_path__ + "img/logoBG.189ae13b.png";